// Cookie utility functions for storing user preferences

export const COOKIE_KEYS = {
  COUNTRY: 'user_country',
  CURRENCY: 'user_currency'
} as const;

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};

export const setCookie = (name: string, value: string, days: number = 365): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// Specific functions for country and currency
export const getStoredCountry = (): string | null => {
  return getCookie(COOKIE_KEYS.COUNTRY);
};

export const getStoredCurrency = (): string | null => {
  return getCookie(COOKIE_KEYS.CURRENCY);
};

export const setStoredCountry = (country: string): void => {
  setCookie(COOKIE_KEYS.COUNTRY, country);
};

export const setStoredCurrency = (currency: string): void => {
  setCookie(COOKIE_KEYS.CURRENCY, currency);
};

export const clearStoredPreferences = (): void => {
  deleteCookie(COOKIE_KEYS.COUNTRY);
  deleteCookie(COOKIE_KEYS.CURRENCY);
}; 